import React, { useState } from "react";
import { Auth0Resource } from "../models/auth0-resource";
import { PageFooterHyperlink } from "./page-footer-hyperlink";
import { TermsAndConditionsModal } from "./common/TermsAndConditionsModal";
import { PrivacyPolicyModal } from "./common/PrivacyPolicyModal";
import { CopyrightStatementModal } from "./common/CopyrightStatementModal";

export const PageFooter = () => {
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isCopyrightModalOpen, setIsCopyrightModalOpen] = useState(false);

  const resourceList: Auth0Resource[] = [
    {
      path: "https://docs.google.com/forms/d/e/1FAIpQLSeb137Z79HtvYCeb59ppvQq8q9q76_AjHmd4tbi-GlUPAIGnw/viewform?usp=sharing&ouid=117310775465521436495",
      label: "Contact Us",
    },
  ];

  const openTermsModal = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsTermsModalOpen(true);
  };

  const closeTermsModal = () => {
    setIsTermsModalOpen(false);
  };

  const openPrivacyModal = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsPrivacyModalOpen(true);
  };

  const closePrivacyModal = () => {
    setIsPrivacyModalOpen(false);
  };

  const openCopyrightModal = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsCopyrightModalOpen(true);
  };

  const closeCopyrightModal = () => {
    setIsCopyrightModalOpen(false);
  };

  return (
    <>
      <footer className="page-footer">
        <div className="page-footer-grid">
          <div className="page-footer-grid__info">
            <div className="page-footer-info__message">
              <p className="page-footer-message__description">
                © 2026 | Gymea Edu — For the love of teaching
              </p>
              <div className="page-footer-acknowledgement">
                <h4 className="page-footer-acknowledgement__title">Acknowledgement Of Country</h4>
                <p className="page-footer-acknowledgement__text">
                  We acknowledge and respect the Dharawal people, the ongoing custodians of the land on which we live and work, and their Elders past, present and future.
                </p>
              </div>
            </div>
            <div className="page-footer-info__resource-list">
              <div className="page-footer-info__resource-list-item">
                <button
                  className="page-footer__hyperlink page-footer__terms-button"
                  onClick={openTermsModal}
                  type="button"
                >
                  Terms of Use
                </button>
              </div>
              <div className="page-footer-info__resource-list-item">
                <button
                  className="page-footer__hyperlink page-footer__terms-button"
                  onClick={openPrivacyModal}
                  type="button"
                >
                  Privacy Policy
                </button>
              </div>
              <div className="page-footer-info__resource-list-item">
                <button
                  className="page-footer__hyperlink page-footer__terms-button"
                  onClick={openCopyrightModal}
                  type="button"
                >
                  Copyright Statement
                </button>
              </div>
              {resourceList.map((resource, index) => (
                <div
                  key={`${resource.label}-${index}`}
                  className="page-footer-info__resource-list-item"
                >
                  <PageFooterHyperlink path={resource.path}>
                    <>{resource.label}</>
                  </PageFooterHyperlink>
                </div>
              ))}
            </div>
          </div>
        </div>
      </footer>
      <TermsAndConditionsModal isOpen={isTermsModalOpen} onClose={closeTermsModal} />
      <PrivacyPolicyModal isOpen={isPrivacyModalOpen} onClose={closePrivacyModal} />
      <CopyrightStatementModal isOpen={isCopyrightModalOpen} onClose={closeCopyrightModal} />
    </>
  );
};
